export const logoTheme = {
  title: 'palette.tertiary.95',
};
